module.exports = __webpack_public_path__ + "img/logo-inline-white-sm.4dee363e.webp";